import { StickerFrame, type StickerArtProps } from './StickerFrame';

export function Animals(props: StickerArtProps) {
  return (
    <StickerFrame background="#ea580c" {...props}>
      <ellipse cx="32" cy="41" rx="10" ry="8.5" fill="#ffffff" />
      <circle cx="19" cy="29" r="4.5" fill="#ffffff" />
      <circle cx="27" cy="21" r="4.5" fill="#ffffff" />
      <circle cx="37" cy="21" r="4.5" fill="#ffffff" />
      <circle cx="45" cy="29" r="4.5" fill="#ffffff" />
    </StickerFrame>
  );
}
